// @flow
import type { Action, User } from '../types';
import { STATUS_PENDING, STATUS_SUCCESS, STATUS_ERROR} from '../middlewares/api';
import * as constants from '../constants/userConstants';

export type State = $ReadOnly<{
    list: $ReadOnlyArray<string>,
    entities: $ReadOnly<{[userId: string]: User}>,
    status: $ReadOnly<{
        fetched: boolean,
        isLoading: boolean,
        isSaving: boolean,
        error: boolean
    }>
}>;

const initialState = {
    list: [],
    entities: {},
    status: {
        fetched: false,
        isLoading: false,
        isSaving: false,
        error: false
    }
};

export default function users(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.FETCH_USERS: {
            if(action.status === STATUS_PENDING) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isLoading: true,
                        error: false
                    }
                };
            }
            else if(action.status === STATUS_SUCCESS) {
                const list = [];
                const entities = {};

                for(let i = 0, length = action.response.length; i < length; i += 1) {
                    const user = action.response[i];
                    list.push(user.uid);
                    entities[user.uid] = user;
                }

                return {
                    ...state,
                    list,
                    entities,
                    status: {
                        ...state.status,
                        fetched: true,
                        isLoading: false,
                        error: false
                    }
                };
            }
            if(action.status === STATUS_ERROR) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isLoading: false,
                        error: true
                    }
                };
            }
            else {
                return state;
            }
        }

        case constants.CREATE_USER: {
            if(action.status === STATUS_PENDING) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isSaving: true,
                        error: false
                    }
                };
            }
            else if(action.status === STATUS_SUCCESS) {
                return {
                    ...state,
                    entities: {
                        ...state.entities,
                        [action.response.uid]: action.response
                    },
                    status: {
                        ...state.status,
                        isLoading: false,
                        error: false
                    }
                };
            }
            if(action.status === STATUS_ERROR) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isSaving: false,
                        error: true
                    }
                };
            }
            else {
                return state;
            }
        }

        case constants.UPDATE_USER: {
            if(action.status === STATUS_PENDING) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isSaving: true,
                        error: false
                    }
                };
            }
            else if(action.status === STATUS_SUCCESS) {
                return {
                    ...state,
                    entities: {
                        ...state.entities,
                        [action.response.uid]: action.response
                    },
                    status: {
                        ...state.status,
                        isLoading: false,
                        error: false
                    }
                };
            }
            if(action.status === STATUS_ERROR) {
                return {
                    ...state,
                    status: {
                        ...state.status,
                        isSaving: false,
                        error: true
                    }
                };
            }
            else {
                return state;
            }
        }

        default:
            return state;
    }
}